import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="mt-16 lg:mt-20 pt-10 pb-8 border-t border-dark-border/30">
      <div className="w-full">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/images/logo_white.png" alt="Nightfall Logo" className="h-6 md:h-7 w-auto opacity-80" draggable={false} />
              <h3 className="font-normal text-lg md:text-xl text-white/70 tracking-tight border-l border-white/20 pl-3">Nightfall</h3>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-white/60 uppercase tracking-wider mb-3">Our Mission</h4>
            <p className="text-xs md:text-sm text-white/50 leading-relaxed">
              Platforms like itch.io have removed games due to payment processor policies, forcing creators to lose their work.
              We offer a platform where adult visual novels can be freely distributed without arbitrary content restrictions.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-white/60 uppercase tracking-wider mb-3">Information</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/about" className="text-xs md:text-sm text-white/50 hover:text-white transition-colors duration-200 w-fit">
                About
              </Link>
              <Link to="/privacy" className="text-xs md:text-sm text-white/50 hover:text-white transition-colors duration-200 w-fit">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-xs md:text-sm text-white/50 hover:text-white transition-colors duration-200 w-fit">
                Terms of Service
              </Link>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
